import { headerService } from '@/services/header-service';

/**
 * 获取是否是特殊IP
 * @returns
 */

export const getIsSpecialIp = async () => {
    await headerService.deferred.promise;
    return headerService.account?.isSpecialIp || false;
};
